define("shared/components/shared/credentials/find-new-page", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/object", "@ember/service", "ember-concurrency-decorators"], function (_exports, _component, _templateFactory, _component2, _object, _service, _emberConcurrencyDecorators) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _class, _descriptor, _descriptor2, _descriptor3;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/object",0,"@ember/service",0,"ember-concurrency-decorators",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Modal
    @close={{action @close}}
    @closable={{false}}
    as
    |modal|
  >
    <modal.card
      @portrait={{true}}
      @closeIcon={{false}}
    >
      <modal.card-header @title={{t "credentials.find_new_page.title"}} />
      <modal.card-body class="u--p__t__0">
        <p>{{html-safe (t "credentials.find_new_page.sub_title" nickname=this.socialProfile.nickname)}}</p>
        <div class="o--formWrapper">
          <Input
            class="o--form__input"
            placeholder={{t "credentials.find_new_page.input_placeholder"}}
            @type="text"
            @id="pageName"
            @value={{this.state.nameOfPage}}
          />
        </div>
        {{#if this.nameOfPage}}
          <div class="u--row u--row--noCollapse u--m__t__lg">
            <div class="u--col__8">
              <p class="u--m__t__sm">
                {{html-safe (t "credentials.find_new_page.is_admin" name=@facebookUser.name)}}
                <Shared::Link
                  @text={{t "credentials.find_new_page.check_role"}}
                  @href={{this.pageRoleSettingsLink}}
                />
              </p>
            </div>
            <div class="u--col__4">
              <div class="o--btnGroup u--float--right">
                <Shared::Ui::Button
                  class="u--p__lr__lg"
                  @type="outline"
                  {{on "click" (fn this.updateIsAdminOfPage true)}}
                  @text={{t "shared_words.yes"}}
                />
                <Shared::Ui::Button
                  class="u--p__lr__lg"
                  @type="outline"
                  {{on "click" (fn this.updateIsAdminOfPage false)}}
                  @text={{t "shared_words.no"}}
                />
              </div>
            </div>
          </div>
        {{/if}}
        {{#if this.notAdminOfPage}}
          <hr>
          <p class="u--m__b__0">{{html-safe (t "credentials.pageItem.not_admin_general")}}</p>
          <ul class="u--p__l__md u--p__t__xs">
            <li>{{t "credentials.pageItem.not_admin_step_1"}}</li>
            <li>{{t "credentials.pageItem.not_admin_step_2"}}</li>
          </ul>
        {{/if}}
      </modal.card-body>
      <modal.card-footer>
        {{#if this.notAdminOfPage}}
          <Shared::Ui::Button
            @type="outline"
            @additional="block"
            @isDisabled={{this.unknownAdminOfPage}}
            @onClick={{action @close}}
            @text={{t "shared_words.ok"}}
          />
        {{else}}
          <Shared::Ui::Button
            @type="primary"
            @additional="block"
            @isDisabled={{this.unknownAdminOfPage}}
            @promise={{task this.startRevoke}}
            @text={{t "shared_words.next"}}
          />
        {{/if}}
      </modal.card-footer>
    </modal.card>
  </Shared::Modal>
  
  */
  {
    "id": "d5VB5FTv",
    "block": "[[[8,[39,0],null,[[\"@close\",\"@closable\"],[[28,[37,1],[[30,0],[30,1]],null],false]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,2,[\"card\"]],null,[[\"@portrait\",\"@closeIcon\"],[true,false]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,2,[\"card-header\"]],null,[[\"@title\"],[[28,[37,2],[\"credentials.find_new_page.title\"],null]]],null],[1,\"\\n    \"],[8,[30,2,[\"card-body\"]],[[24,0,\"u--p__t__0\"]],null,[[\"default\"],[[[[1,\"\\n      \"],[10,2],[12],[1,[28,[35,3],[[28,[37,2],[\"credentials.find_new_page.sub_title\"],[[\"nickname\"],[[30,0,[\"socialProfile\",\"nickname\"]]]]]],null]],[13],[1,\"\\n      \"],[10,0],[14,0,\"o--formWrapper\"],[12],[1,\"\\n        \"],[8,[39,4],[[24,0,\"o--form__input\"],[16,\"placeholder\",[28,[37,2],[\"credentials.find_new_page.input_placeholder\"],null]]],[[\"@type\",\"@id\",\"@value\"],[\"text\",\"pageName\",[30,0,[\"state\",\"nameOfPage\"]]]],null],[1,\"\\n      \"],[13],[1,\"\\n\"],[41,[30,0,[\"nameOfPage\"]],[[[1,\"        \"],[10,0],[14,0,\"u--row u--row--noCollapse u--m__t__lg\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"u--col__8\"],[12],[1,\"\\n            \"],[10,2],[14,0,\"u--m__t__sm\"],[12],[1,\"\\n              \"],[1,[28,[35,3],[[28,[37,2],[\"credentials.find_new_page.is_admin\"],[[\"name\"],[[30,3,[\"name\"]]]]]],null]],[1,\"\\n              \"],[8,[39,6],null,[[\"@text\",\"@href\"],[[28,[37,2],[\"credentials.find_new_page.check_role\"],null],[30,0,[\"pageRoleSettingsLink\"]]]],null],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,0],[14,0,\"u--col__4\"],[12],[1,\"\\n            \"],[10,0],[14,0,\"o--btnGroup u--float--right\"],[12],[1,\"\\n              \"],[8,[39,7],[[24,0,\"u--p__lr__lg\"],[4,[38,8],[\"click\",[28,[37,9],[[30,0,[\"updateIsAdminOfPage\"]],true],null]],null]],[[\"@type\",\"@text\"],[\"outline\",[28,[37,2],[\"shared_words.yes\"],null]]],null],[1,\"\\n              \"],[8,[39,7],[[24,0,\"u--p__lr__lg\"],[4,[38,8],[\"click\",[28,[37,9],[[30,0,[\"updateIsAdminOfPage\"]],false],null]],null]],[[\"@type\",\"@text\"],[\"outline\",[28,[37,2],[\"shared_words.no\"],null]]],null],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[41,[30,0,[\"notAdminOfPage\"]],[[[1,\"        \"],[10,\"hr\"],[12],[13],[1,\"\\n        \"],[10,2],[14,0,\"u--m__b__0\"],[12],[1,[28,[35,3],[[28,[37,2],[\"credentials.pageItem.not_admin_general\"],null]],null]],[13],[1,\"\\n        \"],[10,\"ul\"],[14,0,\"u--p__l__md u--p__t__xs\"],[12],[1,\"\\n          \"],[10,\"li\"],[12],[1,[28,[35,2],[\"credentials.pageItem.not_admin_step_1\"],null]],[13],[1,\"\\n          \"],[10,\"li\"],[12],[1,[28,[35,2],[\"credentials.pageItem.not_admin_step_2\"],null]],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"    \"]],[]]]]],[1,\"\\n    \"],[8,[30,2,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n\"],[41,[30,0,[\"notAdminOfPage\"]],[[[1,\"        \"],[8,[39,7],null,[[\"@type\",\"@additional\",\"@isDisabled\",\"@onClick\",\"@text\"],[\"outline\",\"block\",[30,0,[\"unknownAdminOfPage\"]],[28,[37,1],[[30,0],[30,1]],null],[28,[37,2],[\"shared_words.ok\"],null]]],null],[1,\"\\n\"]],[]],[[[1,\"        \"],[8,[39,7],null,[[\"@type\",\"@additional\",\"@isDisabled\",\"@promise\",\"@text\"],[\"primary\",\"block\",[30,0,[\"unknownAdminOfPage\"]],[28,[37,10],[[30,0,[\"startRevoke\"]]],null],[28,[37,2],[\"shared_words.next\"],null]]],null],[1,\"\\n\"]],[]]],[1,\"    \"]],[]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[2]]]]],[1,\"\\n\"]],[\"@close\",\"modal\",\"@facebookUser\"],false,[\"shared/modal\",\"action\",\"t\",\"html-safe\",\"input\",\"if\",\"shared/link\",\"shared/ui/button\",\"on\",\"fn\",\"task\"]]",
    "moduleName": "shared/components/shared/credentials/find-new-page.hbs",
    "isStrictMode": false
  });

  let FindNewPage = (_dec = (0, _service.inject)('social/instagram-business'), (_class = class FindNewPage extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "credentials", _descriptor, this);

      _initializerDefineProperty(this, "instagramBusiness", _descriptor2, this);

      _initializerDefineProperty(this, "segment", _descriptor3, this);

      _defineProperty(this, "currentPage", null);

      _defineProperty(this, "unknownOfPage", null);
    }

    get socialProfile() {
      return this.credentials.socialProfile;
    }

    get state() {
      return this.credentials.state;
    }

    get activePageId() {
      return this.state.activePage.id;
    }

    get activePageName() {
      var _this$state$activePag;

      return (_this$state$activePag = this.state.activePage) === null || _this$state$activePag === void 0 ? void 0 : _this$state$activePag.name;
    }

    get isAdminOfPage() {
      return this.state.isAdminOfPage;
    }

    get isCorrectPage() {
      return this.state.isCorrectPage;
    }

    get nameOfPage() {
      return this.state.nameOfPage;
    }

    get activePageEqualsGivenPage() {
      return this.activePageName === this.nameOfPage;
    }

    get notAdminOfPage() {
      return !this.isAdminOfPage;
    }

    get unknownAdminOfPage() {
      return this.isAdminOfPage === null;
    }

    get activePageHasSufficientPermissions() {
      const page = this.pages.find(page => page.id === this.activePageId);
      return page && this.instagramBusiness.sufficientPermissions(page, this.socialProfile.isCreator);
    }

    get alternatePageSelected() {
      return !this.isCorrectPage && this.activePageId;
    }

    get pageRoleSettingsLink() {
      if (this.activePageEqualsGivenPage && this.activePageId) {
        return "https://www.facebook.com/".concat(this.nameOfPage, "-").concat(this.activePageId, "/settings/?tab=admin_roles&ref=page_edit");
      }

      return 'https://www.facebook.com/help/187316341316631';
    }

    get instagramSettingsLink() {
      return "https://www.facebook.com/".concat(this.nameOfPage, "-").concat(this.activePageId, "/settings/?tab=instagram_management&ref=page_edit");
    }

    *startRevoke() {
      this.segment.track('declared-missing-page-creds-wiz', {
        social_profile: this.socialProfile,
        fb_page_input: this.nameOfPage,
        page: this.credentials.source
      });
      yield this.args.revokePermissions.perform();
    }

    updateIsAdminOfPage(payload) {
      this.credentials.updateIsAdminOfPage(payload);
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "credentials", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "instagramBusiness", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "startRevoke", [_emberConcurrencyDecorators.task], Object.getOwnPropertyDescriptor(_class.prototype, "startRevoke"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateIsAdminOfPage", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateIsAdminOfPage"), _class.prototype)), _class));
  _exports.default = FindNewPage;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, FindNewPage);
});